import { Injectable } from '@angular/core';
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ServiciosKobraService } from "../../core/http/servicios-kobra/servicios-kobra.service";
import { Menu } from '../modelos/menu.model';
import { ServicesVisitasService } from '../../core/http/services-visitas/services-visitas.service';
import { IServicesTypeKobraResponse } from '../../core/http/servicio-general/servicio-general-response';

@Injectable()
export class LayoutService {
  constructor(
    private kobraService: ServiciosKobraService,
    private servicioVisitas: ServicesVisitasService
  ) { }

  reloadBaseUrl(archivo:string = ""){
    this.kobraService.reloadBaseUrl(archivo);
  }

  public getMenu(): Observable<Array<Menu>> {
    return this.servicioVisitas.get('/menu?idAplicacion=2').pipe(
      map(res => <Array<Menu>> res.data)
    );
  }

  /**
   * Obtiene la ruta completa del logo desde el servicio de Visitas
   * @param idFinanciera ID de la financiera
   * @param country Código del país
   * @returns Observable con la ruta completa del logo
   */
  public obtenerRutaLogo(idFinanciera: number, country: string): Observable<IServicesTypeKobraResponse<any>> {
    // Usar la ruta específica que sabemos que es correcta
    const rutaCorrecta = `/clientes/logo/${idFinanciera}`;

    return this.servicioVisitas.get(rutaCorrecta).pipe(
      catchError(error => {
        // Crear un objeto del tipo correcto en caso de error
        const emptyResponse: IServicesTypeKobraResponse<any> = {
          data: null,
          error: { message: 'No se pudo obtener la ruta del logo' },
          success: false,
          type: 'error'
        };
        return of(emptyResponse);
      })
    );
  }
}
